import { render, staticRenderFns } from "./DeliveryChangeDriverForm.vue?vue&type=template&id=60f35a43&lang=pug&"
import script from "./DeliveryChangeDriverForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryChangeDriverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports